import React from 'react';
import { noop } from '@yme/utils/common';
import { NavLink } from './NavLink';
import { Menu } from './VerticalMenuStyled';
export function VerticalMenu(props) {
    const { links, isRightToLeft, onClick } = props;
    const onItemClick = (link) => {
        if (!onClick) {
            return noop;
        }
        return () => {
            onClick(link);
        };
    };
    return (React.createElement(Menu, { isRightToLeft: isRightToLeft }, links.map((link) => (React.createElement(NavLink, { key: link.linkTitle, onClick: onItemClick(link), isRightToLeft: isRightToLeft, ...link })))));
}
